import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetById,
} from "adminApi/TaxManagementApi/TaxManagement";
import fields from "../json/TaxListFeilds.json";
import { validateForm } from "utils/validation";
import { TaxManagementRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditTaxManagementForm from "./Componates/EditTaxManagementForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditTexManagement = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, TaxManagementRules);

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, TaxManagementRules)
      setErrors(err);
      return err;
    },
    () => {

      return navigate(-1)
    },
    "Tax updated successfully"
  );
  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditTaxManagementForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update"
      />
    </>
  );
};

export default EditTexManagement;
